export { default } from './FieldLockIndicator';
